const validate = {

    date(dateString) {
        // Accepts YYYY-MM-DD or DD/MM/YYYY
        if (!dateString) return false;
        let d;
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            d = new Date(dateString);
        } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
            const [day, month, year] = dateString.split('/').map(Number);
            d = new Date(year, month - 1, day);
        } else {
            return false;
        }
        return d instanceof Date && !isNaN(d.getTime());
    },

    phone: {
        br(phone) {
            // Accepts only digits, 10 or 11 digits (with or without DDD)
            if (!phone) return false;
            const cleaned = phone.replace(/\D/g, '');
            return cleaned.length === 10 || cleaned.length === 11;
        }
    },

    cpf(cpf) {
        // Only digits, 11 digits, and passes CPF validation algorithm
        if (!cpf) return false;
        cpf = cpf.replace(/\D/g, '');
        if (cpf.length !== 11 || /^([0-9])\1+$/.test(cpf)) return false;
        let sum = 0, rest;
        for (let i = 1; i <= 9; i++) sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
        rest = (sum * 10) % 11;
        if ((rest === 10) || (rest === 11)) rest = 0;
        if (rest !== parseInt(cpf.substring(9, 10))) return false;
        sum = 0;
        for (let i = 1; i <= 10; i++) sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
        rest = (sum * 10) % 11;
        if ((rest === 10) || (rest === 11)) rest = 0;
        if (rest !== parseInt(cpf.substring(10, 11))) return false;
        return true;
    },
    cnpj(cnpj) {
        // Only digits, 14 digits, and passes CNPJ validation algorithm
        if (!cnpj) return false;
        cnpj = cnpj.replace(/\D/g, '');
        if (cnpj.length !== 14 || /^([0-9])\1+$/.test(cnpj)) return false;
        let length = cnpj.length - 2;
        let numbers = cnpj.substring(0, length);
        let digits = cnpj.substring(length);
        let sum = 0;
        let pos = length - 7;
        for (let i = length; i >= 1; i--) {
            sum += parseInt(numbers.charAt(length - i)) * pos--;
            if (pos < 2) pos = 9;
        }
        let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
        if (result !== parseInt(digits.charAt(0))) return false;
        length = length + 1;
        numbers = cnpj.substring(0, length);
        sum = 0;
        pos = length - 7;
        for (let i = length; i >= 1; i--) {
            sum += parseInt(numbers.charAt(length - i)) * pos--;
            if (pos < 2) pos = 9;
        }
        result = sum % 11 < 2 ? 0 : 11 - sum % 11;
        if (result !== parseInt(digits.charAt(1))) return false;
        return true;
    }
}

export default validate;